<template>
	<div class="fun_box">
		<!--<div class="warnBox contentBox">
			<img src="./img/lingdang.png">
			<div class="overflow">
				<h3>关于救援平台使用的说明</h3>
				<p>平台正式上线，各位服务商在使用过程中有任何问题，可随时联系江泰运营指挥中心，电话：+86 10 68180898，邮箱：ops@jiangtai.com</p>
			</div>
			<p class="text">2018.09.09</p>
		</div>-->
		<div class="contentBox" style="padding-top: 20px;">
			<h2>功能查询</h2>
			<div class="fun_list">
				<div class="fun_one fun" @click="tofinish">
					<img src="../../../static/images/com_images/icon_07.png" alt="">
					<span>已完成案件查询</span>
				</div>
				<!--<div class="fun_one fun">
					<img src="../../../static/images/com_images/icon_10.png" alt="">
					<span>保单导入</span>
				</div>-->
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		methods: {
			tofinish() {
				this.$router.push({
					name: "Finish2",
					params: {
						token: this.$route.params.token || JSON.parse(window.localStorage.getItem("data")).data
					}
				});
			}
		}
	};
</script>

<style scoped>
	.fun_box {
		background-color: white;
		padding: 0 0 50px 0;
	}
	
	.contentBox {
		width: 1200px;
		margin: 0 auto;
	}
	
	h2 {
		font-size: 20px;
		color: #333;
	}
	
	.fun_one {
		margin-top: 20px;
		cursor: pointer;
	}
	
	.fun_one img {
		vertical-align: middle;
	}
	
	.fun_one span {
		vertical-align: middle;
		font-size: 18px;
		padding-left: 10px;
		color: #666;
	}
	
	.warnBox {
		overflow: hidden;
		padding: 50px 0;
	}
	
	.warnBox img {
		float: left;
	}
	
	.warnBox .overflow {
		float: left;
		margin-left: 20px;
	}
	
	.warnBox .overflow h3 {
		font-size: 18px;
		font-weight: normal;
	}
	
	.warnBox .overflow p {
		font-size: 14px;
		line-height: 30px;
		color: #666;
	}
	
	.warnBox .text {
		float: right;
		color: #666;
	}
	
	.fun_list {
		overflow: hidden;
	}
	
	.fun_list .fun_one {
		float: left;
		margin-left: 20px;
	}
</style>


// WEBPACK FOOTER //
// src/views/branch/footer.vue